// extracted by mini-css-extract-plugin
export default {"wrapper":"warning_wrapper__POcTp","icon":"warning_icon__ldax8","link":"warning_link__mQn9w","display":"warning_display__4jac+","hide":"warning_hide__csufP"};